import { render, staticRenderFns } from "./scroll-container.vue?vue&type=template&id=3567dcd4&scoped=true&"
import script from "./scroll-container.vue?vue&type=script&lang=js&"
export * from "./scroll-container.vue?vue&type=script&lang=js&"
import style0 from "./scroll-container.vue?vue&type=style&index=0&id=3567dcd4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3567dcd4",
  null
  
)

export default component.exports